
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { MapStoreModule } from "@/store/modules/mapStore";
import GoogleMap from "vue2-google-maps/src/components/map.vue";
import GmapCluster from "vue2-google-maps/src/components/cluster.js";
import GmapMarker from "vue2-google-maps/src/components/marker.js";
import StorePopUp from "@/components/StorePopUp.vue";
import { GMapsStyle } from "@/utils/helpers.ts";
import { config } from "@/utils/config/config.ts";
import closable from "@/closable-directive.ts";

interface CenterType {
  lat: number;
  lng: number;
}


interface MarksType {
  id: number;
  position: CenterType;
  type: string;
}
@Component({
  components: {
    GoogleMap,
    GmapCluster,
    GmapMarker,
    StorePopUp
  },
  directives: {
    closable
  }
})
export default class GoogleMapWrap extends Vue {
  @Prop() marks!: Array<object>;
  @Prop() center!: { lat: number; lng: number };
  private position = { lat: 0, lng: 0 };
  private numDeltas = 9;
  private delay = 50;
  private refresh = 0;
  private deltaLat = 0;
  private deltaLng = 0;
  private activeWindow: any;
  private popupEnabled: any;
  private tempPinNumberLat = 0;
  private visiblePinArea = 0.33;
  private icons = {
    default: config.appImgUrl + "images/map_pin_def.png",
    active: config.appImgUrl + "images/map_pin.png"
  };
  private simpleMarks: MarksType[] = [];
  private configs: any;
  private gmapStyle = GMapsStyle;

  get availableStores() {
    return MapStoreModule.stores;
  }

  get existStores(): boolean {
    return MapStoreModule.isActiveStatus;
  }

  get isPinCluster(): boolean {
    if (!this.configs['map-pin-cluster'] || this.configs['map-pin-cluster'] == '') {
      return false
    }
    return true
  }

  get isOptimizedPin(): boolean {
    if (!this.configs['map-pin-optimized'] || this.configs['map-pin-optimized'] == '') {
      return false
    }
    return true
  }

  private isMarkAvailable(markValue: number) {
    return markValue
  }

  get centerMark() {
    return MapStoreModule.center;
  }

  get isPopUp(): boolean {
    return MapStoreModule.activePopUp && MapStoreModule.isGalleryCollection
  }

  private beforeCreate() {
    this.popupEnabled = true;
    this.configs = Vue.prototype.$globalConfig
    if (!this.configs['popup-window'] || this.configs['popup-window'] == '') {
      this.popupEnabled = false;
    }
  }

  private onClosePopUp() {
    MapStoreModule.togglePopUp(false);
  }

  private setActivePin(id: number): void {
    const myElement = document.getElementById("list-" + id);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const topPos = myElement.offsetTop;
    setTimeout(() => {
      document
          .getElementsByClassName("distrib-view")[0]
          .scrollTo({ top: topPos - 130, behavior: "smooth" });
      MapStoreModule.changeStore(id);
      MapStoreModule.togglePopUp(false);
    }, 100);
  }

  @Watch("position")
  onPosition() {
    if (!this.isOptimizedPin) {
      this.simpleMarks = MapStoreModule.marks
      return;
    }

    if (this.position.lat === 0 && this.position.lng === 0) {
      return;
    }
    const tempPositionLat = this.position.lat < 0 ? this.position.lat * -1 : this.position.lat
    const tempPositionLng = this.position.lng < 0 ? this.position.lng * -1 : this.position.lng

    if (this.tempPinNumberLat === 0 || this.calcLatDifference(tempPositionLat)) {
      this.tempPinNumberLat = tempPositionLat;
    }
    if (tempPositionLat != this.tempPinNumberLat) {
      return
    }

    this.simpleMarks = []
    MapStoreModule.marks.forEach((value, i) => {
      const tempMarkLat = value.position.lat < 0 ? value.position.lat * -1 : value.position.lat
      const tempMarkLng = value.position.lng < 0 ? value.position.lng * -1 : value.position.lng

      if ((this.calcBetweenPositions(tempPositionLat, tempMarkLat) <= this.visiblePinArea &&
              this.calcBetweenPositions(tempPositionLng, tempMarkLng) <= this.visiblePinArea) &&
          (this.calcBetweenPositions(tempPositionLat, tempMarkLat) >= 0 ||
              this.calcBetweenPositions(tempPositionLng, tempMarkLng) >= 0) ) {
        this.simpleMarks.push(value)
        return
      }
      if ( ( this.calcBetweenPositions((tempPositionLat + this.visiblePinArea), tempMarkLat) <= this.visiblePinArea &&
              this.calcBetweenPositions((tempPositionLng + this.visiblePinArea), tempMarkLng) <= this.visiblePinArea) &&
          ( this.calcBetweenPositions((tempPositionLat + this.visiblePinArea), tempMarkLat) >= 0 ||
              this.calcBetweenPositions((tempPositionLng + this.visiblePinArea), tempMarkLng) >= 0) ) {
        this.simpleMarks.push(value)
      }
    })
  }

  @Watch("centerMark")
  onCenterMark() {
    if (this.position.lat === 0 && this.position.lng === 0) {
      this.position = this.centerMark;
      return;
    }
    if (this.refresh > 0 && this.refresh != this.numDeltas) {
      return;
    }
    this.refresh = 0;
    this.transition();
  }

  private clickPosition() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    if (this.$refs.map.$mapObject && this.$refs.map.$mapObject.getCenter()) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.position = this.$refs.map.$mapObject.getCenter().toJSON();
    }
    return;
  }

  private transition(): void {
    this.deltaLat = (this.centerMark.lat - this.position.lat) / this.numDeltas;
    this.deltaLng = (this.centerMark.lng - this.position.lng) / this.numDeltas;
    this.movingTo();
    return;
  }

  private movingTo(): any {
    if (this.refresh != this.numDeltas) {
      this.wait(this.delay).then(() => {
        this.refresh++;
        this.position.lat += this.deltaLat;
        this.position.lng += this.deltaLng;
        if (this.activeWindow) {
          clearTimeout(this.activeWindow)
        }
        this.movingTo();
      });
    }
    if (this.refresh === this.numDeltas) {
      this.activeWindow = setTimeout(() => {
        MapStoreModule.togglePopUp(true);
      }, 100);
      return;
    }
    return;
  }
  private wait(t): any {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, t);
    });
  }

  private calcLatDifference(tempPositionLat: number): boolean {
    let difference = 0;

    if (tempPositionLat > this.tempPinNumberLat) {
      difference = tempPositionLat - this.tempPinNumberLat
      if (difference >= (this.visiblePinArea / 4)) {
        return true
      }
    }

    if (tempPositionLat < this.tempPinNumberLat) {
      difference = this.tempPinNumberLat - tempPositionLat
      if (difference >= (this.visiblePinArea / 4)) {
        return true
      }
    }

    return false;
  }

  private calcBetweenPositions(number1: number, number2: number) {
    if (number1 > number2) {
      return number1 - number2;
    }
    return number2 - number1;
  }
}
